import React, { Component } from 'react';
import classNames from 'classnames';
import ImageText from '../../../../components/ImageText/';
import { t } from '../../../../locales';
import './styles.scss';
import moment from 'moment';

import { connect } from 'react-redux';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { isApp, resolvePublicAssets } from '../../../../utils';

import InfoBlue from '../../../../assets/images/vhis/infoBlue@3x.png';
import { goto } from '../../../../actions/historyActions';
import _ from 'lodash';
import Collapsible from '@axa-asia/emma-stylesheet/lib/components/Collapsible/Collapsible';

import {
  AXA_GOAL_LEVEL_NEWBIE,
  AXA_GOAL_LEVEL_CRYSTAL,
  AXA_GOAL_LEVEL_JADE,
  AXA_GOAL_LEVEL_DIAMOND,
  AXA_GOAL_SH_LEVEL_NEWBIE,
  AXA_GOAL_SH_LEVEL_NEWBIE_ACHIEVED,
} from '../../constants/constants';

interface VhisSummaryBoardProps {
  ruleType: 'SH' | 'WGP';
  sImgSrc: string;
  sImageDes: string;
  nArchievedDate: string;
  nBonusDays: string;
  aArchievedData: Array<any>;
  isApp: boolean;
  isFirstYear?: boolean;
  children?: any;
  currentAchievedDays: string;
  targetAchievedDays: string;
  togglePremiumRebateModal: (toggle: boolean) => void;
  entityCode: string;
}

class VhisSummaryBoard extends Component<VhisSummaryBoardProps> {
  constructor(props: any) {
    super(props);
    this.dataMomentFormat = this.dataMomentFormat.bind(this);
  }

  componentDidMount() {
    if (isApp()) {
      const title = t(`ACHIEVEMENTSUMMARYTITLE`);
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
    }
  }

  dataMomentFormat(date: string) {
    return moment(date).format('MM / YYYY');
  }

  onGoToRecord = (
    month: string,
    achieveDays: string,
    ruleType: 'WGP' | 'SH',
    entityCode: string,
  ) => {
    goto(
      `emma-vhis/recode-type/achieve-days?month=${month}&achieveDays=${achieveDays}&ruleType=${ruleType}&entityCode=${entityCode}`,
    );
  };

  getRebate = (sImageDes: string) => {
    if (this.props.ruleType === 'SH') {
      if (sImageDes.toLocaleUpperCase() === AXA_GOAL_SH_LEVEL_NEWBIE) {
        return 0;
      }
      if (sImageDes.toLocaleUpperCase() === AXA_GOAL_SH_LEVEL_NEWBIE_ACHIEVED) {
        return 10;
      }
    }
    if (sImageDes.toLocaleUpperCase() === AXA_GOAL_LEVEL_NEWBIE) {
      return 0;
    }
    if (sImageDes.toLocaleUpperCase() === AXA_GOAL_LEVEL_CRYSTAL) {
      return 5;
    }
    if (sImageDes.toLocaleUpperCase() === AXA_GOAL_LEVEL_JADE) {
      return 10;
    }
    if (sImageDes.toLocaleUpperCase() === AXA_GOAL_LEVEL_DIAMOND) {
      return 20;
    }
    return 0;
  };

  render() {
    const {
      sImgSrc,
      sImageDes,
      nArchievedDate,
      nBonusDays,
      aArchievedData,
      isApp,
      isFirstYear,
      currentAchievedDays,
      targetAchievedDays,
      ruleType,
      entityCode,
    } = this.props;

    const silverHairTextPrefix = ruleType === 'SH' ? 'SH_' : '';
    const archieveLength = aArchievedData.length;
    let firstArchievedData: Array<any>;
    let secondArchievedData: Array<any>;
    if (archieveLength > 3) {
      firstArchievedData = _.take(aArchievedData, 3);
      secondArchievedData = _.takeRight(aArchievedData, archieveLength - 3);
    } else {
      firstArchievedData = aArchievedData;
      secondArchievedData = [];
    }
    const SummaryBoardClasses = classNames({
      'summary-board': true,
    });
    const calWidth =
      (parseInt(currentAchievedDays, 10) / parseInt(targetAchievedDays, 10)) *
        100 || 0;
    const rebate = this.getRebate(sImageDes);
    return (
      <div className={SummaryBoardClasses}>
        <div className="summary-board__col summary-board__col--left">
          <ImageText
            imgSrc={sImgSrc}
            imgAlt={sImageDes}
            vertical={true}
            large={true}
            small={false}
          >
            <div className="image-text-rebate">
              <span className="image-text-rebate-text">
                {rebate}% {t('ACHIEVEMENT_SUMMARY_PREMIUM_REBATE')}
              </span>
              <img
                className="info-blue"
                src={InfoBlue}
                alt=""
                onClick={() => this.props.togglePremiumRebateModal(true)}
                data-enable-ga
                data-ga-type="button"
                data-ga-text="tooltip"
              />
            </div>

            <div className="progress">
              <div className="progress-top">
                <div className="progress-top-left">{t(`DAYS2`)}</div>
                <div>
                  <span className="progress-top-txt">
                    {currentAchievedDays}
                  </span>
                  /{targetAchievedDays}
                </div>
              </div>
              <div className="progress-middle">
                <div
                  style={{ width: `${calWidth > 100 ? 100 : calWidth}%` }}
                ></div>
              </div>
              {(nBonusDays === '25' || nBonusDays === '50') && (
                <div className="progress-bottom">
                  {t('ACHIEVEMENT_SUMMARY_FIRST_YEAR_BONUS').replace(
                    '${nBonusDays}',
                    nBonusDays,
                  )}
                </div>
              )}
              {nBonusDays === '75' && (
                <div className="progress-bottom">
                  {t('ACHIEVEMENT_SUMMARY_EARLY_BIRD_BONUS').replace(
                    '${nBonusDays}',
                    nBonusDays,
                  )}
                </div>
              )}
            </div>

            {/* {!isApp && (
              <p className="image-text__txt__title">
                {t('ARCHEVED')} {nArchievedDate} {t('DAYS')}
                {nBonusDays !== '0' && <span className="summary-board__txt summary-board__txt--emma-blue">
                  + {nBonusDays} {t(`DAYS2`)}*
                </span>}
              </p>
            )} */}
          </ImageText>

          {/* {isApp && (
            <p className="summary-board__detail__remark">
              <b>
                {t('ARCHEVED')} {nArchievedDate} {t('DAYS')}
                {nBonusDays !== '0' && <span className="summary-board__txt--emma-blue">
                  +{nBonusDays} {t(`DAYS2`)}*
                  </span>}
              </b>
            </p>
          )} */}
        </div>
        <div className="summary-board__col summary-board__col--right">
          <div className="summary-board__detail">
            <div className="summary-board__detail__head">
              <div>{t(`MONTH`)}</div>
              <div>{t(`ACHIEVED_DAYS2`)}</div>
            </div>
            {aArchievedData && aArchievedData.length == 0 && (
              <div className="summary-board__detail__body">
                <div>-</div>
                <div>-</div>
              </div>
            )}
            {firstArchievedData &&
              firstArchievedData.map((item) => (
                <div
                  className="summary-board__detail__body"
                  key={item.month}
                  onClick={() =>
                    this.onGoToRecord(
                      item.month,
                      item.numberOfAchievedDays,
                      ruleType,
                      entityCode,
                    )
                  }
                  data-enable-ga
                  data-ga-type="button"
                >
                  <div>{this.dataMomentFormat(item.month)}</div>
                  <div className="summary-board__detail__body-achieve-days content-align-right">
                    <div className="summary-board__detail__body-achieve-days-number">
                      {item.numberOfAchievedDays}
                    </div>
                    <div className="summary-board__detail__body-achieve-days-icon">
                      <img
                        src={resolvePublicAssets(
                          `assets/images/vhis/arrow-bigger-right.svg`,
                        )}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              ))}
            {secondArchievedData && secondArchievedData.length > 0 && (
              <Collapsible
                showText={t('ACHIEVEMENT_SUMMARY_SHOW_MORE_MONTHS')}
                hideText={t('ACHIEVEMENT_SUMMARY_SHOW_LESS_MONTHS')}
                type="showMore"
              >
                {secondArchievedData.map((item) => (
                  <div
                    className="summary-board__detail__body"
                    key={item.month}
                    onClick={() =>
                      this.onGoToRecord(
                        item.month,
                        item.numberOfAchievedDays,
                        ruleType,
                        entityCode,
                      )
                    }
                    data-enable-ga
                    data-ga-type="button"
                  >
                    <div>{this.dataMomentFormat(item.month)}</div>
                    <div className="summary-board__detail__body-achieve-days content-align-right">
                      <div className="summary-board__detail__body-achieve-days-number">
                        {item.numberOfAchievedDays}
                      </div>
                      <div className="summary-board__detail__body-achieve-days-icon">
                        <img
                          src={resolvePublicAssets(
                            `assets/images/vhis/arrow-bigger-right.svg`,
                          )}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </Collapsible>
            )}

            <div className="summary-board__detail__footer content-align">
              <div>
                {t(`${silverHairTextPrefix}ACHIEVEMENT_SUMMARY_REMARK`)}
              </div>
            </div>
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default connect()(VhisSummaryBoard);
